// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 205 ? "ed48eaa7" : chunkId) + "." + {"97":"0c5467b638eefdd9","205":"da9b0d4810707c17","736":"b6f2bc03691b8e69"}[chunkId] + ".js";
};